import { motion } from 'framer-motion';
import { Wallet, TrendingUp, FileText, Calendar, PieChart, ShieldCheck } from 'lucide-react';

export const Features = () => {
  const features = [
    {
      icon: Wallet,
      title: 'Contas a Pagar',
      description: 'Controle as suas despesas. Projete seu caixa futuro e nunca mais perca um prazo.',
      color: '#EF4444',
    },
    {
      icon: TrendingUp,
      title: 'Contas a Receber',
      description: 'Acompanhe seus recebimentos. Saiba o que entra no caixa e não deixe dinheiro na mesa.',
      color: '#10B981',
    },
    {
      icon: FileText,
      title: 'Relatório DRE',
      description: 'Demonstrativo de Resultado do Exercício: entenda seu lucro real, otimize custos e tome decisões inteligentes.',
      color: '#F59E0B',
    },
    {
      icon: PieChart,
      title: 'Fluxo de Caixa',
      description: 'Visualize de forma clara com fluxo projetado até 360 dias. Planeje suas metas para o futuro.',
      color: '#3B82F6',
    },
    {
      icon: Calendar,
      title: 'Vencimentos',
      description: 'Evite multas e surpresas negativas no seu caixa com lembretes automáticos próximos dos vencimentos.',
      color: '#8B5CF6',
    },
    {
      icon: ShieldCheck,
      title: 'Dados Seguros',
      description: 'Seus dados financeiros totalmente protegidos com criptografia de ponta e backup automático. Sua tranquilidade é prioridade.',
      color: '#047857',
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <section id="features" className="section-padding bg-[#F8FAFC]" data-testid="features-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="inline-block px-4 py-2 bg-[#D1FAE5] text-[#065F46] rounded-full text-sm font-semibold mb-4" data-testid="features-badge">
            Funcionalidades
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0F172A] mb-4" data-testid="features-title">
            Tudo que você precisa para{' '}
            <span className="text-[#047857]">o seu negócio crescer</span>
          </h2>
          <p className="text-lg text-[#64748B] max-w-2xl mx-auto" data-testid="features-description">
            Ferramentas completas para planejar o fluxo financeiro do seu negócio de forma simples e eficiente.
          </p>
        </motion.div>

        {/* Features Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          data-testid="features-grid"
        >
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              variants={itemVariants}
              className="feature-card group"
              data-testid={`feature-card-${index}`}
            >
              <div
                className="w-14 h-14 rounded-2xl flex items-center justify-center mb-6 transition-transform group-hover:scale-110"
                style={{ backgroundColor: `${feature.color}15` }}
              >
                <feature.icon className="w-7 h-7" style={{ color: feature.color }} />
              </div>
              <h3 className="font-heading text-xl font-bold text-[#0F172A] mb-3">
                {feature.title}
              </h3>
              <p className="text-[#64748B] leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
